import React, { useEffect, useState, useRef } from 'react';
import { Container } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { getUserActionHistory } from '../../utils/mainServices';
import { toggleLoader } from '../../shared/actions/setting';
import { useTranslation } from 'react-i18next';
import { useParams } from "react-router-dom";
import FeatherIcon from "feather-icons-react";


const UserHistory = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [historyList, setHistoryList] = useState([]);
  const [isFetchingData, setIsFetchingData] = useState(false);
  const [isAllRetrieved, setIsAllRetrieved] = useState(false);
  const [page, setPage] = useState(1);
  const {id} = useParams();
  const scrollableDivRef = useRef(null);

  const fetchActions = async (page) => {
    if (isFetchingData || isAllRetrieved) return;

    setIsFetchingData(true);
    if (page === 1) {
      dispatch(toggleLoader(true));
    }

    try {
      const userId = id;
      const offset = 20; 
      const order = 'DESC';
      const response = await getUserActionHistory(userId, offset, page, order);

      if (response.content.length < offset) {
        setIsAllRetrieved(true); 
      }

      setHistoryList((prevHistory) => [...prevHistory, ...response.content]);
    } catch (err) {
      console.error('Error fetching user action history:', err);
    } finally {
      setIsFetchingData(false);
      if (page === 1) {
        dispatch(toggleLoader(false));
      }
    }
  };

  useEffect(() => {
    fetchActions(page); 
  }, [page]); 

  useEffect(() => {
    const handleScroll = () => {
      const scrollableDiv = scrollableDivRef.current;
      
      if (
        scrollableDiv.scrollHeight - scrollableDiv.scrollTop === scrollableDiv.clientHeight && 
        !isFetchingData &&
        !isAllRetrieved
      ) {
        setPage((prevPage) => prevPage + 1); 
      }
    };

    const scrollableDiv = scrollableDivRef.current;
    scrollableDiv.addEventListener('scroll', handleScroll);

    return () => {
      scrollableDiv.removeEventListener('scroll', handleScroll);
    };
  }, [isFetchingData, isAllRetrieved]);

  return (
    <Container>
      <div className="full-list-view position-sticky">
        <div className="single-card m-rl-m-8 p-a-16">
          <div className="sa-table-flex" style={{ marginBottom: 8 }}>
            <div className="xin-pull-left">
              <span className="sa-table-icon-flex sa-table-filter-position">
                <button
                  onClick={() => window.history.back()}
                  className={`sa-table-btn-secondary sa-table-float-left`}>
                  <FeatherIcon
                    icon={"chevron-left"}
                    className={"sa-table-icon-size"}/> {"  Back"}
                </button>
              </span>
            </div>
          </div>
          <div className="sa-table-container xindicate-calc-height" ref={scrollableDivRef}>
            <table className="table table-borderless">
              <thead>
                <tr>
                  <th className="sa-table-head-sticky">ID</th>
                  <th className="sa-table-head-sticky">Action</th>
                  <th className="sa-table-head-sticky">Action At</th>
                </tr>
              </thead>
              <tbody>
                {historyList.length > 0 ? (
                  historyList.map((item, index) => (
                    <tr key={index}>
                      <td className="sa-table-data">{index + 1}</td>
                      <td className="sa-table-data">{item.action}</td>
                      <td className="sa-table-data">{item.actionAt}</td>
                    </tr>
                  ))
                ) : isFetchingData ? (
                  <tr>
                    <td colSpan="3" className="text-center">
                      Loading...
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center">
                      No logs available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          </div>
        </div>

        {isFetchingData && !isAllRetrieved && (
          <div style={{ width: '100%', textAlign: 'center', marginTop: '10px' }}>
            Fetching more data...
          </div>
        )}

        {isAllRetrieved && (
          <div style={{ width: '100%', textAlign: 'center', marginTop: '10px' }}>
            All data loaded.
          </div>
        )}
    </Container>
  );
};

export default UserHistory;
